'use client';
import { Button, Typography } from '@curology/ui-components-web/react';
import { useMemo } from 'react';

import { useVisitContext } from '@/services/visitsService/hooks/useVisitContext';

import PhotoUploadAccordion from './components/photoUploadAccordion';
import { type PhotoUploader } from './types/types';
import { useNavigation } from '../../hooks/useNavigation';

const ClientContainer = ({
  title,
  description,
  ctaText,
  uploaders,
}: {
  title: string;
  description?: string;
  ctaText: string;
  uploaders: PhotoUploader[];
}) => {
  const { onNext } = useNavigation();
  const { visit } = useVisitContext();

  const canProceed = useMemo(() => {
    return (
      uploaders
        .filter((uploader) => uploader.required)
        .filter(
          (uploader) =>
            !visit?.photos?.some(
              (photo) =>
                photo.metadata.photo_perspective === uploader.perspective,
            ),
        ).length === 0
    );
  }, [uploaders, visit]);

  return (
    <section>
      <Typography size="h2">{title}</Typography>
      <Typography className="cur-mt-6" size="body">
        {description}
      </Typography>

      <div className="cur-mt-6">
        {uploaders.map((uploader, i) => (
          <PhotoUploadAccordion
            key={uploader.perspective}
            uploader={uploader}
            title={`${i + 1}. ${uploader.title}`}
          />
        ))}
      </div>

      <div className="cur-mt-6">
        <Button
          className="cur-w-full"
          type="button"
          onClick={onNext}
          disabled={!canProceed}
        >
          {ctaText}
        </Button>
      </div>
    </section>
  );
};

export { ClientContainer };
